import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ActionConfirmModal from '../../common/components/actionConfirmModal';
import PermissaoUsuario from '../../auth/permissao';
import { showUpdate, remove, setPaginaAtual } from './viaturaActions';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';
import { filtrarPorAtivo, filtrarPorTexto, renderSituacaoBadge } from '../manutencaoListUtils';

const FILTRO_TODOS = '';

function formatarPosicao(viatura) {
  if (viatura.ultima_posicao_em) {
    return new Date(viatura.ultima_posicao_em).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }
  if (viatura.ultima_lat) {
    return `${viatura.ultima_lat}, ${viatura.ultima_lng}`;
  }
  return '—';
}

class ViaturaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroBusca: '',
      filtroAtivo: FILTRO_TODOS,
      excluirViatura: null,
    };
    this.remover = this.remover.bind(this);
    this.confirmarExclusaoViatura = this.confirmarExclusaoViatura.bind(this);
    this.cancelarExclusaoViatura = this.cancelarExclusaoViatura.bind(this);
    this.handleBuscaChange = this.handleBuscaChange.bind(this);
    this.handleAtivoChange = this.handleAtivoChange.bind(this);
  }

  handleBuscaChange(event) {
    this.setState({ filtroBusca: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handleAtivoChange(event) {
    this.setState({ filtroAtivo: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  remover(data) {
    this.setState({ excluirViatura: data });
  }

  confirmarExclusaoViatura() {
    const { excluirViatura } = this.state;
    if (!excluirViatura) return;
    this.props.remove(excluirViatura);
    this.setState({ excluirViatura: null });
  }

  cancelarExclusaoViatura() {
    this.setState({ excluirViatura: null });
  }

  renderFiltros() {
    const { filtroBusca, filtroAtivo } = this.state;

    return (
      <div className="os-list-filters-bar">
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="viatura-list-filtro-busca">
            Buscar
          </label>
          <input
            id="viatura-list-filtro-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroBusca}
            onChange={this.handleBuscaChange}
            placeholder="Placa, descrição ou equipe..."
          />
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="viatura-list-filtro-ativo">
            Situação
          </label>
          <select
            id="viatura-list-filtro-ativo"
            className="form-control os-list-filter-select"
            value={filtroAtivo}
            onChange={this.handleAtivoChange}
          >
            <option value={FILTRO_TODOS}>Todas</option>
            <option value="1">Ativas</option>
            <option value="0">Inativas</option>
          </select>
        </div>
      </div>
    );
  }

  render() {
    const viaturas = this.props.list || [];
    const viaturasFiltradas = filtrarPorAtivo(
      filtrarPorTexto(viaturas, ['placa', 'descricao', 'equipe_nome', 'imei'], this.state.filtroBusca),
      this.state.filtroAtivo,
    );

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="os-actions-cell">
            <div className="os-actions-group">
              <PermissaoUsuario tela="CadManutencaoViatura" campo="alterar" condicao={true}>
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.props.showUpdate(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoViatura" campo="excluir" condicao={true}>
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir"
                  onClick={() => this.remover(row.original)}
                />
              </PermissaoUsuario>
            </div>
          </div>
        ),
        className: 'column_icon',
        width: 80,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Placa',
        accessor: 'placa',
        width: 110,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-numero">{row.value}</span>,
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        minWidth: 180,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value || '—'}</span>,
      },
      {
        Header: 'IMEI',
        accessor: 'imei',
        width: 150,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-numero">{row.value || '—'}</span>,
      },
      {
        Header: 'Equipe',
        accessor: 'equipe_nome',
        width: 160,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value || '—'}</span>,
      },
      {
        Header: 'Situação',
        accessor: 'ativo',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => renderSituacaoBadge(row.value),
      },
      {
        Header: 'Última posição',
        accessor: 'ultima_posicao_em',
        width: 150,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-data">{formatarPosicao(row.original)}</span>,
      },
    ];

    return (
      <div className="manutencao-premium-list table-container">
        <div className="os-list-top-panel">
          <p className="os-list-summary">{`${viaturasFiltradas.length} viatura(s)`}</p>
          {this.renderFiltros()}
        </div>
        <PremiumTableShell summary="" hideToolbar tableMinWidth={0}>
          <ReactTableGT2A
            data={viaturasFiltradas}
            columns={columns}
            className="-striped -highlight"
            defaultPageSize={15}
            showPagination
            filterable={false}
            onPageChange={this.handlePageChange}
            page={this.props.paginaAtual}
            minRows={0}
          />
        </PremiumTableShell>

        <ActionConfirmModal
          show={!!this.state.excluirViatura}
          title="Deseja realmente excluir?"
          message="A viatura será removida permanentemente do cadastro."
          itemName={this.state.excluirViatura ? this.state.excluirViatura.placa : ''}
          itemDetail={
            this.state.excluirViatura && this.state.excluirViatura.equipe_nome
              ? this.state.excluirViatura.equipe_nome
              : ''
          }
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoViatura}
          onCancel={this.cancelarExclusaoViatura}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.manutencaoViatura.list,
  paginaAtual: state.manutencaoViatura.paginaAtual,
});
const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove, setPaginaAtual }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ViaturaList);
